/**
 * Breadcrumb collection component.
 *
 * On product pages, reads the referring collection from sessionStorage
 * (set when browsing a collection page) and dynamically inserts
 * the Shop + Collection breadcrumb links before the product title.
 *
 * Rendered breadcrumb: Home / Shop / Collection Title / Product Title
 */
class BreadcrumbCollection extends HTMLElement {
  connectedCallback() {
    this.style.display = "contents";

    try {
      const raw = sessionStorage.getItem("breadcrumb_collection");
      if (!raw) return;

      const {url, title} = JSON.parse(raw);
      if (!url || !title) return;

      const collectionSeparator = document.createElement("i");
      collectionSeparator.textContent = "/";

      const collectionLink = document.createElement("a");
      collectionLink.href = url;
      collectionLink.title = title;
      collectionLink.textContent = title;

      this.appendChild(collectionSeparator);
      this.appendChild(collectionLink);
    } catch {
      // Silently fail if sessionStorage is unavailable
    }
  }
}

if (!customElements.get("breadcrumb-collection")) {
  customElements.define("breadcrumb-collection", BreadcrumbCollection);
}
